import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import ErrorPage from "./ErrorPage";

const NotAuthorizedPage = observer(props => <ErrorPage {...props} />);

NotAuthorizedPage.propTypes = {
  title: PropTypes.string,
  helpText: PropTypes.string,
  continueUrl: PropTypes.string,
  continueText: PropTypes.string,
};

NotAuthorizedPage.defaultProps = {
  title: "Not Authorized",
  helpText: "You are not allowed to access this page.",
  continueUrl: `${window.location.protocol}//${window.location.hostname}/login/promptLogin`,
};

export default NotAuthorizedPage;
